import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "self-center z-10 fixed statistics slide-up h-[450px] bg-white rounded-lg shadow-2xl border-black px-5 py-5 bottom-[13%]" }
const _hoisted_2 = { class: "grid w-[322px] sm:w-[422px]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "justify-self-center text-3xl font-bold" }, "לא הצליח הפעם", -1)
const _hoisted_4 = { class: "flex gap-x-2 justify-center" }
const _hoisted_5 = { class: "justify-self-center text-2xl pt-3 font-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "justify-self-center text-2xl pt-3" }, "מילת היום היתה", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "justify-self-end text-xl pt-4 pr-8" }, ":שתפו את התוצאה", -1)
const _hoisted_8 = { class: "flex bg-green-500 rounded-2xl py-4 px-4 mx-5 mt-4 justify-around" }
const _hoisted_9 = { class: "grid bg-white rounded-lg text-right px-2 py-2 w-[126px]" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-10 w-10 sm:h-14 sm:w-14 self-center\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"white\" version=\"1.1\" viewBox=\"0 0 724.18 806.76\"><g transform=\"translate(1193.5 499.59)\"><g color=\"#000\" transform=\"matrix(0 -17.254 17.254 0 10443 -2252.9)\"><path d=\"M-134.38 309.5a7.547 7.547 0 11-15.095 0 7.547 7.547 0 0115.095 0z\" transform=\"translate(1.105 -949.48)\"></path><path d=\"M-134.38 309.5a7.547 7.547 0 11-15.095 0 7.547 7.547 0 0115.095 0z\" transform=\"translate(32.767 -949.48)\"></path><path d=\"M-134.38 309.5a7.547 7.547 0 11-15.095 0 7.547 7.547 0 0115.095 0z\" transform=\"translate(16.936 -976.35)\"></path><path d=\"M488.22 -443.73H515.912V-440.73H488.22z\" transform=\"rotate(-60.001)\"></path><path d=\"M613.16 -226.9H640.852V-223.9H613.16z\" transform=\"scale(-1 1) rotate(-60)\"></path></g></g></svg><h2 class=\"text-white text-2xl self-center\">לשיתוף</h2>", 2)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "righttoleft text-center pt-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl" }, "המילה הבאה תופיע מחר, בהצלחה!")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.wordoftheday), 1),
        _hoisted_6
      ]),
      _hoisted_7,
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleShare()))
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridImage, (tiles, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "grid gap-3 justify-center",
                key: index
              }, _toDisplayString(tiles), 1))
            }), 128))
          ]),
          _hoisted_10
        ])
      ]),
      _hoisted_12
    ])
  ]))
}